import React from 'react';
import { Route, Switch, Redirect, useRouteMatch, useLocation } from 'react-router-dom';
import { Box } from 'rebass';
import { object } from 'prop-types';

import TableServerSideProvider from '~COMPONENTS/tableServerSide/TableServerSideContext';
import UnderlineNavigation from '../../../components/UnderlineNavigation';
import LinkedContracts from './LinkedContracts';
import LinkedAccounts from './LinkedAccounts';

import { columnSortModifiersLinkedContracts, columnFilterModifiersLinkedContracts } from './linkedContractsColumns';
import { columnSortModifiersLinkedAccounts, columnFilterModifiersLinkedAccounts } from './linkedAccountsColumns';

const LinkedContractsAndAccounts = ({ productContractGroup }) => {
  const { url, path } = useRouteMatch();
  const { pathname } = useLocation();

  const initialActiveTab = pathname.indexOf('linkedAccounts') !== -1 ? 1 : 0;

  return (
    <Box>
      <Box mt='5px'>
        <UnderlineNavigation
          list={[
            { title: 'Linked Contracts', href: `${url}/linkedContracts` },
            { title: 'Linked Accounts', href: `${url}/linkedAccounts` }
          ]}
          initialActiveTab={initialActiveTab}
        />
      </Box>
      <Box>
        <Switch>
          <Route exact path={path}>
            <Redirect to={{ pathname: `${url}/linkedContracts` }} />
          </Route>
          <Route exact path={`${path}/linkedContracts`}>
            <TableServerSideProvider
              tableId='linkedContracts'
              columnSortModifiers={columnSortModifiersLinkedContracts}
              columnFilterModifiers={columnFilterModifiersLinkedContracts}
            >
              <LinkedContracts
                productContractGroupId={productContractGroup.id}
                linkedContractIds={productContractGroup.contracts}
              />
            </TableServerSideProvider>
          </Route>
          <Route exact path={`${path}/linkedAccounts`}>
            <TableServerSideProvider
              tableId='linkedAccounts'
              columnSortModifiers={columnSortModifiersLinkedAccounts}
              columnFilterModifiers={columnFilterModifiersLinkedAccounts}
            >
              <LinkedAccounts
                productContractGroupId={productContractGroup.id}
                linkedAccountIds={productContractGroup.accounts}
              />
            </TableServerSideProvider>
          </Route>
        </Switch>
      </Box>
    </Box>
  );
};

LinkedContractsAndAccounts.propTypes = {
  productContractGroup: object.isRequired
};

export default LinkedContractsAndAccounts;
